import * as constants from './actions';
import { NativePaymentsTypes } from '../../utils/enums';

const initialState = {
    applePayReady: false,
    awaitingBraintreeResponse: false,
    customAmount: '',
    isCustomDonation: false,
    isCustomDonationDelay: false,
    isSubmitting: false,
    mobileWizardStep: 1,
    selectedAmount: 10,
    showCreditCardForm: false,
    supportedNativePaymentTypes: [NativePaymentsTypes.credtCard],
    venmoReady: false,
    orgHunterCcValidity: {
        cardNumber: false,
        expDate: false,
        cvv: false
    }
};

function getTimeFrom(fromDate) {
    return (new Date() - fromDate) / 1000;
}

function supportedPaymentsCheck(arr, type) {
    if (arr.includes(type)) {
        return arr;
    } else {
        return [...arr, type];
    }
}

export default function donation(state = initialState, { type, payload }) {
    switch (type) {
        case constants.AWAITING_BRAINTREE_RESPONSE:
            return {
                ...state,
                awaitingBraintreeResponse: payload
            };
        case constants.SET_PAYMENT_INFO:
            return {
                ...state,
                paymentInfo: payload
            };
        case constants.SET_NATIVE_PAYMENT_AVAILABILITY:
            return {
                ...state,
                supportedNativePaymentTypes: supportedPaymentsCheck(
                    state.supportedNativePaymentTypes,
                    payload
                )
            };
        case constants.SET_DEVICE_DATA:
            return {
                ...state,
                deviceData: payload
            };
        case constants.SELECT_AMOUNT:
            return {
                ...state,
                selectedAmount: payload,
                selectedAmountTime: new Date()
            };
        case constants.DONATE_MORE:
            return { ...state, isCustomDonation: payload };
        case constants.CUSTOM_AMOUNT_CHANGED:
            return { ...state, customAmount: payload };
        case constants.DONATION_PAYMENT_PROVIDER_SELECTED:
            return { ...state, selectedPaymentProvider: payload };
        case constants.CLEAR_DONATION_PAYMENT_PROVIDER:
            return {
                ...state,
                selectedPaymentProvider: undefined,
                showCreditCardForm: false
            };
        case constants.REVEAL_CREDIT_CARD_FORM:
            return { ...state, showCreditCardForm: payload };
        case constants.DONATION_SUCCESS:
            return {
                ...state,
                completeDonation: payload,
                actionCompleteTime: getTimeFrom(state.selectedAmountTime),
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier]
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                successInfo: payload
            };
        case constants.DONATION_SUBMITTING:
            return {
                ...state,
                isSubmitting: payload
            };
        case constants.MOBILE_GO_WIZARD_STEP:
            return {
                ...state,
                mobileWizardStep: payload
            };
        case constants.DONATION_SUBMITTING_ERROR:
            return {
                ...state,
                donationSubmitError: payload
            };
        case constants.DONATION_GO_BACK_TO_AMOUNT:
            return {
                ...state,
                cancelTime: getTimeFrom(state.selectedAmountTime)
            };
        case constants.DONATION_ORGHUNTER_VALIDITY_CHANGE:
            return {
                ...state,
                orgHunterCcValidity: {
                    ...state.orgHunterCcValidity,
                    [payload.fieldName]: payload.isValid
                }
            };
        default:
            return state;
    }
}
